// Indian numbering system formatter (lakhs / crores)
export const formatINR = (value, opts = {}) => {
  const { withSymbol = true, decimals = 0 } = opts;
  const num = Number(value);
  if (!isFinite(num)) return withSymbol ? "₹ 0" : "0";
  const formatted = new Intl.NumberFormat("en-IN", {
    maximumFractionDigits: decimals,
    minimumFractionDigits: decimals,
  }).format(num);
  return withSymbol ? `₹ ${formatted}` : formatted;
};

export const formatPct = (value, decimals = 1) => {
  const num = Number(value);
  if (!isFinite(num)) return "0%";
  return `${num.toFixed(decimals)}%`;
};

export const parseNumber = (raw) => {
  if (raw === null || raw === undefined || raw === "") return 0;
  const cleaned = String(raw).replace(/[^\d.-]/g, "");
  const n = parseFloat(cleaned);
  return isFinite(n) ? n : 0;
};
